import api from "../../Services/api";

export const fetchHistoryLogs = async () => {
  try {
    const response = await api.get("/logs");
    return response;
  } catch (error) {
    console.error("Error fetching History Logs:", error);
    throw error;
  }
};
